import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Typography, Table, TableHead, TableCell, TableBody, TableRow } from '@material-ui/core';
import Button from '@material-ui/core/Button'
import PaginatorComponent from 'common/components/Paginator';
import Paper from 'common/components/CudaPaper';
import ExpiredApps from '../expiredApps/ExpiredAppsContainer';

const styles = {
    typography: {
        display: 'inline-block'
    },
    tabButton: {
        backgroundColor: 'transparent',
        color: 'black'
    },
    tableCell: {
        textAlign: 'center',
    },
    topBox: {
        // boxShadow: '-3px 3px 5px 0 rgba(0,0,0,0.26), 1px 2px 10px 1px rgba(0,0,0,0.16)', // slightly different - some top shadow
        // backgroundColor: "#f7f7f7",
        // borderBottom: "1px solid #DDDDDD",
        // padding: '5px',
        height: '44px',
    },
    bottomBox: {
        extend: 'topBox',
        width: '100%',
        paddingTop: '5px'
    },
    paper: {
        width: '100%',
    },
    paginator: {
        paddingTop: '10px'
    }
}
class Licenses extends React.Component {
    render() {
        const {
            classes,
            // isLoading,
            licenses,
            // fetchLicenses,
            isSaaS,
            pageNumber,
            itemsPerPage,
            itemsTotal,
            pageChange,
            // onPreviousClick,
            changeitemsPerPage,
            setSaaS,
        } = this.props;

        return <Grid container style={{ width: '100%' }} spacing={1}>
            <Grid item xs={12}>
            <Grid item container xs={12} justifyContent="center">
                <Button className={classes.tabButton} variant={isSaaS ? "outlined" : "text"} onClick={() => setSaaS(true)}>SaaS</Button>
                <Button className={classes.tabButton} variant={isSaaS ? "text" : "outlined"} color='secondary' onClick={() => setSaaS(false)}>Non-SaaS</Button>
            </Grid>
            <Grid item container xs={12}>
            <Paper style={{ width: '100%' }} containerPaper={classes.paper}>
                <Grid item xs={12}>

                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.tableCell}>Serial</TableCell>
                                <TableCell className={classes.tableCell}>License Type</TableCell>
                                <TableCell className={classes.tableCell}>Assignment Date</TableCell>
                                <TableCell className={classes.tableCell}>Expiration Date</TableCell>
                                <TableCell className={classes.tableCell}>Account</TableCell>
                                <TableCell className={classes.tableCell}>#Apps</TableCell>
                                <TableCell className={classes.tableCell}>Bandwidth (Mbps)</TableCell>
                                <TableCell className={classes.tableCell}>Plan</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {
                                licenses.map((license, licenseIndex) =>
                                    <TableRow>
                                        <TableCell className={classes.tableCell}>{license.serial_number}</TableCell>
                                        <TableCell className={classes.tableCell}>{license.license_type}</TableCell>
                                        <TableCell className={classes.tableCell}>{license.assignment_date}</TableCell>
                                        <TableCell className={classes.tableCell}>{license.expiration_date}</TableCell>
                                        <TableCell className={classes.tableCell}><Typography variant="overline" color="primary" className={classes.typography}>{license.account_id}</Typography> - {license.account_name}</TableCell>
                                        <TableCell className={classes.tableCell}>{license.num_of_apps}</TableCell>
                                        <TableCell className={classes.tableCell}>{license.additional_bandwidth_mbps}</TableCell>
                                        <TableCell className={classes.tableCell}>{license.plan.name}</TableCell>
                                    </TableRow>
                                )
                            }

                        </TableBody>
                    </Table>

                </Grid>
                <Grid item xs={12} className={classes.bottomBox}>

                    <PaginatorComponent pageNumber={pageNumber} itemsTotal={itemsTotal}
                        countSelector={true} changeitemsPerPage={(event) => { changeitemsPerPage(event.target.value) }} itemsPerPage={itemsPerPage}
                        onNextClick={() => pageChange(1)} onPreviousClick={() => pageChange(-1)}
                    />

                </Grid>
            </Paper>
            </Grid>
            </Grid>
            <Grid item xs={12}>
                <ExpiredApps />
            </Grid>
        </Grid>

    }
}

export default withStyles(styles)(Licenses)
